import { api } from "boot/axios";

import useMembership from "src/use/membership";

export default () => {
  //chukul Traning Session
  const chukulTraningSession = async (session) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/payment/traders/availability/?session=${session}`)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //Esewa Payment
  const esewaPay = async (id, request) => {
    useMembership().clearMembershipCache();
    return new Promise((resolve, reject) => {
      api
        .post("/payment/package/" + id + "/esewa", request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const esewaPayV2 = async (request) => {
    useMembership().clearMembershipCache();
    return new Promise((resolve, reject) => {
      api
        .post("/payment/v2/package/esewa", request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //Esewa Payment trader
  const esewaPayTrader = async (request) => {
    return new Promise((resolve, reject) => {
      api
        .post("/payment/traders/esewa/", request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //Khalti Payment
  const khaltiPay = async (id, request) => {
    useMembership().clearMembershipCache();
    return new Promise((resolve, reject) => {
      api
        .post("/payment/package/" + id + "/khalti", request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const initialteKhaltiPaymentV2 = async (req) => {
    useMembership().clearMembershipCache();
    return new Promise((resolve, reject) => {
      api.post("payment/v2/package/khalti/", req).then((res) => {
        resolve(res);
      });
    });
  };

  const khaltiPaymentVerificationV2 = async (req) => {
    useMembership().clearMembershipCache();
    return new Promise((resolve, reject) => {
      api
        .post("payment/v2/package/khalti/verification/", req)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  //Khalti Payment trader
  const khaltiPayTrader = async (request) => {
    return new Promise((resolve, reject) => {
      api
        .post("/payment/traders/khalti/", request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // Initiate Payment
  const initiatePayment = async (id, check, version, request) => {
    useMembership().clearMembershipCache();
    return new Promise((resolve, reject) => {
      let url = `payment/${version}/package/${id}/initiate-payment`;
      if (check) {
        url = `payment/package/extra/9/initiate-payment`;
      }
      api
        .post(url, request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // Initiate Trade Payment
  const initiateTradePayment = async (request) => {
    return new Promise((resolve, reject) => {
      let url = `/payment/traders/initiate-payment/`;
      api
        .post(url, request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //ConnectIPS Generate Token
  const connectIPSToken = async (request) => {
    try {
      const data = await api.post(
        "/payment/connectips/generate-token",
        request
      );

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };
  //ConnectIPS Trader Generate Token
  const traderConnectIPSToken = async (request) => {
    try {
      const data = await api.post(
        "/payment/traders/connectips/generate-token/",
        request
      );

      return data;
    } catch (error) {
      throw error;
    }
  };

  //ConnectIPS Token Payment Validation
  const connectIPSValidationToken = async (request) => {
    useMembership().clearMembershipCache();
    return new Promise((resolve, reject) => {
      api
        .post("/payment/connectips/generate-token-payment-validation", request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //ConnectIPS Trader Token Payment Validation
  const traderConnectIPSValidationToken = async (request) => {
    return new Promise((resolve, reject) => {
      api
        .post(
          "payment/traders/connectips/generate-token-payment-validation/",
          request
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //ConnectIPS Payment
  const connectIPSPay = async (id, request) => {
    return new Promise((resolve, reject) => {
      api
        .post("/payment/package/" + id + "/connectips", request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  //ConnectIPS Payment trader
  const connectIPSTrader = async (request) => {
    return new Promise((resolve, reject) => {
      api
        .post("/payment/traders/connectips/", request)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // paymentProvider On/Off
  const paymentProvider = async () => {
    return new Promise((resolve, reject) => {
      api
        .get("/payment/providers/")
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    chukulTraningSession,
    khaltiPaymentVerificationV2,
    initialteKhaltiPaymentV2,
    esewaPay,
    khaltiPay,
    connectIPSToken,
    connectIPSValidationToken,
    connectIPSPay,
    initiatePayment,
    initiateTradePayment,
    esewaPayTrader,
    khaltiPayTrader,
    connectIPSTrader,

    traderConnectIPSToken,
    traderConnectIPSValidationToken,
    paymentProvider,
    esewaPayV2,
  };
};
